export var DefaultReviewSummarySetting;
(function (DefaultReviewSummarySetting) {
    DefaultReviewSummarySetting["DISABLED"] = "DISABLED";
    DefaultReviewSummarySetting["ENABLED"] = "ENABLED";
})(DefaultReviewSummarySetting || (DefaultReviewSummarySetting = {}));
